module.exports = ".card-header img {\n  max-height: 55px; }\n"